import {NgTemplateOutlet} from "@angular/common"
import {Component, computed, inject, input, signal, ChangeDetectionStrategy} from "@angular/core"
import {GetJobDetailsForTemplateImageViewerQuery} from "@app/template-editor/components/template-image-viewer/template-image-viewer.component.generated"
import {JobData, isJobError, isJobPending} from "@app/template-editor/helpers/template-jobs"
import {MatTooltipModule} from "@angular/material/tooltip"
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner"
import {RouterLink} from "@angular/router"
import {PermissionsService} from "@common/services/permissions/permissions.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-job-icon",
    imports: [MatTooltipModule, MatProgressSpinnerModule, RouterLink, NgTemplateOutlet],
    templateUrl: "./template-job-icon.component.html",
    styleUrl: "./template-job-icon.component.scss",
})
export class TemplateJobIconComponent {
    readonly $job = input.required<GetJobDetailsForTemplateImageViewerQuery["job"]>({alias: "job"})
    readonly $can = inject(PermissionsService).$to
    readonly $iconClass = computed(() => {
        const job = this.$job()
        if (isJobPending(job)) return "far fa-hourglass"
        else return isJobError(job) ? "far fa-exclamation-triangle" : "fas fa-image"
    })

    readonly $tooltip = computed(() => {
        const job = this.$job()
        if (isJobPending(job)) return `${job.state} - ${job.progress ?? "?"}%`
        else return `${job.state}`
    })

    readonly $isJobPending = signal(isJobPending)
    readonly $isJobError = signal(isJobError)
    isJobComplete = (job: JobData) => !isJobPending(job) && !isJobError(job)
}
